export default "__VITE_ASSET__CpcUL2NV__"